import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const stripeConfigSchema = z.object({
  pricingTableId: z.string(),
  publishableKey: z.string(),
  userEmail: z.string().email(),
  userId: z.string(),
});

export class StripeConfigDto extends createZodDto(stripeConfigSchema) {} 